import React, { useState, useEffect } from "react";
import { Button, Modal, Layout, Table, Icon, Input } from "antd";
import _ from "i18n";
import { connect } from "react-redux";
import { getUnpaidInvoicesDetails, displayNotPaidInvoicesCsvFile, displayNotPaidInvoicesPdfFile } from "../../../actions/thunks.js";
import { setFilteredNotPaidItems } from "../../../actions/actions.js";
import { formatAmount } from "utils";
import { map, reduce, set } from 'lodash';
import moment from "moment";
import { formatPhoneNumber } from "../../../services/utils";


const { Search } = Input;

const UnpaidInvoicesDetails = ({statisticsFilter,
  notPaidInvoicesDetails,
  recapByDay,
  auth,
  getUnpaidInvoicesDetails,
  setFilteredNotPaidItems,
  displayNotPaidInvoicesCsvFile,
  displayNotPaidInvoicesPdfFile,
  operationType
}) => {

  const [search, setSearch] = useState('');
  const [showSpinner, setShowSpinner] = useState(false);

  const columns = [
    {
      title: _("credit-note-number"),
      dataIndex: "officialNumber",
      align: "left",
      width: 91
    },
    {
      title: _("Date"),
      dataIndex: "documentDate",
      align: "left",
      width: 74,
      render: date => moment(date).format("DD/MM/YYYY")
    },

    {
      title: _("vcs"),
      dataIndex: "vcs",
      align: "left",
      width: 101,

    },


    {
      title: _("user-email"),
      align: "left",
      dataIndex: "user.mainEmail",
      width: 235,

    },

    {
      title: _("user-phone"),
      align: "left",
      dataIndex: "user.mainPhone",
      width: 105,
      render: phone => formatPhoneNumber(phone)

    },

    {
      title: _("organization"),
      dataIndex: "clientOrganization",
      align: "left",
      width: 125,

    },


    {
      title: _("comment"),
      dataIndex: "comment",
      align: "left",
      width: 259,

    },


    {
      title: _("To"),
      align: "center",
      dataIndex: "issuer.abbreviation",
      width: 81,

    },


    {
      title: _("amount"),
      dataIndex: "includingVatAmount",
      align: "center",
      width: 56,

      render: amount => formatAmount(amount)
    },

    {
      title: _("Status"),
      align: "center",
      dataIndex: "status",
      width: 45,
      render: (text, record) => _(record.status)

    },

  ];

  const loadUpaindInvoicesDetails = () => {
    getUnpaidInvoicesDetails(statisticsFilter.apps && statisticsFilter.apps.length > 0 ? statisticsFilter.apps : [], statisticsFilter.appRefs && statisticsFilter.appRefs.length > 0 ? statisticsFilter.appRefs : [], auth.currentClient ? auth.currentClient.id : null, statisticsFilter.year && statisticsFilter.year.length > 0 ? statisticsFilter.year : [], statisticsFilter.appType && statisticsFilter.appType.length > 0 ? statisticsFilter.appType : [])
  }

  useEffect(() => {
    if (statisticsFilter.apps && statisticsFilter.apps.length > 0) {
      loadUpaindInvoicesDetails();
    }
  }, []);

  useEffect(() => {
    if (operationType !== null) {
      loadUpaindInvoicesDetails();
    }
  }, [operationType]);

  const calculSum = () => {
    return (notPaidInvoicesDetails.filteredItems || []).reduce((sum, { includingVatAmount, manual }) => {
      sum += parseInt(includingVatAmount);
      if (manual && manual.amount) {
        sum -= parseInt(manual.amount);
      }
      return sum
    }, 0
    )
  };


  const getCsvFile = () => {
    sethowSpinner(true);
    displayNotPaidInvoicesCsvFile(statisticsFilter.apps && statisticsFilter.apps.length > 0 ? statisticsFilter.apps : [], statisticsFilter.appRefs && statisticsFilter.appRefs.length > 0 ? statisticsFilter.appRefs : [], search.trim() !== '' ? search.trim() : null, auth.currentClient ? auth.currentClient.id : null, statisticsFilter.year && statisticsFilter.year.length > 0 ? statisticsFilter.year : []).then((res) => {
      setShowSpinner(false);
    });
  };

  const getPdfFile = () => {
    setShowSpinner(true);
    displayNotPaidInvoicesPdfFile(statisticsFilter.apps && statisticsFilter.apps.length > 0 ? statisticsFilter.apps : [], statisticsFilter.appRefs && statisticsFilter.appRefs.length > 0 ? statisticsFilter.appRefs : [], search.trim() !== '' ? search.trim() : null, auth.currentClient ? auth.currentClient.id : null, statisticsFilter.year && statisticsFilter.year.length > 0 ? statisticsFilter.year : []).then((res) => {
      setShowSpinner(false);
    });
  };

  const handleSearch = (value) => {
    setSearch(value);
    let results = notPaidInvoicesDetails.items.filter((elem) => {

      return (contains(elem.user.mainEmail, value.trim()) || contains(elem.vcs, value.trim()) || contains(elem.clientOrganization, value.trim()) || contains(elem.comment, value.trim()))
    });
    setFilteredNotPaidItems(results);

  };

  const contains = (name, text) => {
    if (name === null) return;
    return (name.trim()).search(new RegExp(text, 'gi')) !== -1 || (name.trim()).search(new RegExp(text, 'gi')) === 0;
  };

  return (
    <div className="stats-invoice-detail ">

      <div className="bg-blue-lightest h-16 modal-header-title">
        Factures non payées
      </div>

      <div className="flex flex-row justify-between mt-8" >

        <div className="flex items-center justify-start">
          <div className="recap-day-title">
            {_('Invoices')}

          </div>

          <div className="ml-2" onClick={getCsvFile} style={{ cursor: 'pointer' }}>
            <Icon type="file-excel" style={{ fontSize: '20px', color: '#2495e1' }} />
          </div>

          <div className="ml-2" onClick={getPdfFile} style={{ cursor: 'pointer' }}>
            <Icon type="file-pdf" style={{ fontSize: '20px', color: '#2495e1' }} />
          </div>

        </div>
        <div className="w-1/3">
          <Search
            placeholder="input search text"
            onChange={({ target: { value } }) => handleSearch(value)}
            size={"small"}
            allowClear={true}
            value={search.trim()}
          />

        </div>
      </div>

      <div className="pt-4  pb-8 relative">

        <Table
          rowKey="id"
          columns={columns}
          //dataSource={notPaidInvoicesDetails.filteredItems.length > 0 ? notPaidInvoicesDetails.filteredItems : null}
          dataSource={
            notPaidInvoicesDetails.filteredItems &&
              notPaidInvoicesDetails.filteredItems.length > 0
              ? notPaidInvoicesDetails.filteredItems
              : []
          }

          loading={notPaidInvoicesDetails.fetching}
          pagination={false}
          size="middle"
          className="ttp-invoice-detail-tab table-padding"
          scroll={{ x: false, y: 400 }}
        />

        {showSpinner ? <div className="div-fetching-file flex items-center justify-center ">

          <Icon type="sync" spin style={{ fontSize: '50px' }} />

        </div> : null
        }

      </div>

      <div className="flex flex-row justify-between pt-4  self-end pb-8">
        <div className="pr-4 border-right-line"> TOTAL</div>
        <div className="div-recap-amount-total"> {formatAmount(calculSum())} </div>
      </div>
    </div>
  );
}

const mapStateToProps = state => ({
  statisticsFilter: state.filters.statisticsFilter,
  notPaidInvoicesDetails: state.notPaidInvoicesDetails,
  recapByDay: state.recapByDay,
  auth: state.auth,
});

const mapDispatchToProps = {
  getUnpaidInvoicesDetails,
  setFilteredNotPaidItems,
  displayNotPaidInvoicesCsvFile,
  displayNotPaidInvoicesPdfFile
};

export default connect(mapStateToProps, mapDispatchToProps)(UnpaidInvoicesDetails);



// WEBPACK FOOTER //
// ./app/components/Admin/statisctics/UnpaidInvoicesDetails.js